import { DatePicker, Input, Table, Modal, Button } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate } from "../../util";
import { numberFormat } from "../../util";
import UserListModal from "../../components/user/UserListModal";
import moment from "moment";

const Search = Input.Search;
const { RangePicker } = DatePicker;

const statusString = [
  '신청중',
  '승인',
  '거절'
];

class SwapBetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      userListVisible: false,
      selectedUser: {idx: 0, name: '전체', id: ''},
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getList();
  }
  getList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.swaptalkBettingList,[10,pageNum,this.state.selectedUser.idx],{}).then((res) => {
      this.setState({
        tables: res.data.list,
      });
    });
  };
  getRoundFromDate = date => {
    return moment(date, 'YYYYMMDDHHmm').hour() * 60 + moment(date, 'YYYYMMDDHHmm').minute();
  }
  render() {
    const { tables } = this.state;
    const columns = [
        {
          title: "날짜",
          dataIndex: "gameTime",
          className: "support-column-number fs-15 lh-21",
          render: value => moment(value, 'YYYYMMDDHHmm').format('YYYY-MM-DD')
        },
        {
          title: "회차",
          dataIndex: "gameTime",
          className: "support-column-number fs-15 lh-21",
          render: value => this.getRoundFromDate(value)
        },
        {
          title: "아이디",
          dataIndex: "userId",
          className: "support-column-number fs-15 lh-21",
        },
        {
          title: "이름",
          dataIndex: "userName",
          className: "support-column-number fs-15 lh-21",
        },
        {
          title: "USDT",
          dataIndex: "usdtValue",
          className: "support-column-number fs-15 lh-21",
          render: value => numberFormat(value/1000000)
        },
        {
          title: "선택",
          dataIndex: "choice",
          className: "support-column-number fs-15 lh-21",
        },
        {
          title: "수수료",
          dataIndex: "feeRatio",
          className: "support-column-number fs-15 lh-21",
          render: value => <div style={{color: value < 0 ? 'red' : value > 0 ? 'blue' : 'black'}}>{value}</div>
        },
        {
          title: "유저수익",
          dataIndex: "feeRatio",
          className: "support-column-number fs-15 lh-21",
          render: (value, row) => <div style={{color: value < 0 ? 'red' : value > 0 ? 'blue' : 'black'}}>{value * row.usdtValue / 100000000 * -1}</div>
        },

    ];

    return (
      <div>
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
          }}>
          실시간 베팅내역
      </div>
        <div className="wrapper mt-35 width-1240" />
          <div className="flex-row flex-center" style={{paddingBottom: '10px', justifyContent: 'space-between'}}>
            <div className="flex-row flex-center">
                <Button
                style={{ marginLeft: "10px" }}
                onClick={() => {
                    this.setState({userListVisible: true});
                }}>
                회원검색
                </Button>
                <Button
                style={{ marginLeft: "10px" }}
                onClick={() => {
                    this.setState({
                        selectedUser: {idx: 0, name: '전체', id: ''},
                        pagination: { total: 0, current: 1 },
                    }, this.getList);
                }}>
                전체보기
                </Button>
                <div style={{paddingLeft: '20px'}}>
                    현재검색조건: {this.state.selectedUser.name + (this.state.selectedUser.id && ('('+this.state.selectedUser.id+')'))}
                </div>
            </div>
            <div className="flex-row flex-center">

                <div>{this.state.pagination.current} page</div>
                <Button
                style={{ marginLeft: "10px" }}
                onClick={() => {
                    if (this.state.pagination.current <= 1) return;
                    this.setState({
                        pagination: { total: 0, current: this.state.pagination.current-1 },
                    }, this.getList);
                }}>
                이전
                </Button>
                <Button
                style={{ marginLeft: "10px" }}
                onClick={() => {
                    if (tables.length == 0) return;
                    this.setState({
                        pagination: { total: 0, current: this.state.pagination.current+1 },
                    }, this.getList);
                }}>
                다음
                </Button>
            </div>
          </div>
        <Table
          dataSource={tables}
          columns={columns}
          pagination={false}
        />
        <UserListModal
          visible={this.state.userListVisible}
          onOk={(value) => {
            this.setState({
                selectedUser: {idx: value.idx, name: value.name, id: value.id},
                pagination: { total: 0, current: 1 },
                userListVisible: false,
            }, this.getList);
          }}
          onCancel={() => {
            this.setState({
              userListVisible: false,
            });
          }}
        />
      </div>
    );
  }
}

export default SwapBetting;
